<template>
	<div class="p-guide">
		<div class="container">
			<div class="row">
				<div
					class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-10 offset-sm-1"
				>
					<h1 @click="onTrigger">
						Welcome! <span class="say-hello" ref="hello">👋</span>
					</h1>
					<p>
						UnderlineMe is a tool for collecting text snippets from any webpage.
					</p>
					<hr />
					<Faq></Faq>
					<hr />
					<KeyboardShortcuts></KeyboardShortcuts>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import anime from 'animejs';
import Faq from '@/components/faq.vue';
import KeyboardShortcuts from '@/components/ui/keyboard-shortcuts.vue';

export default {
	components: {
		Faq,
		KeyboardShortcuts,
	},
	data: function () {
		return {};
	},
	methods: {
		onTrigger: function () {
			var url = browser.runtime.getURL('/icons/active-38.png');
			var isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
			browser.runtime
				.sendMessage({ action: 'highlighter:activated', isDark: isDark })
				.then((response) => {});
		},
		animateHello: function () {
			var keyframes = [];
			var counter = false;
			for (var i = 0; i < 6; i++) {
				var deg = '20deg';
				counter = !counter;
				if (counter) {
					deg = '0deg';
				}
				keyframes.push({
					duration: 130,
					rotate: deg,
					direction: 'alternate',
					easing: 'easeInOutQuad',
				});
			}
			keyframes.push({
				duration: 210,
				rotate: '0deg',
				direction: 'alternate',
				easing: 'easeInOutQuad',
			});
			anime({
				targets: this.$refs.hello,
				keyframes: keyframes,
			});
		},
	},
	mounted: function () {
		this.animateHello();
	},
};
</script>

<style lang="scss">
.p-guide {
	padding: 1.5rem;

	.say-hello {
		display: inline-block;
		transform-origin: bottom right;
	}

	.infobox {
		position: relative;
		margin-bottom: 1rem;

		padding: 1rem;
		border-radius: 7px;
		background-color: var(--s3);
		box-shadow: 0 1.8px 3px rgba(0, 0, 0, 0.048),
			0 6px 10.1px rgba(0, 0, 0, 0.072), 0 27px 45px rgba(0, 0, 0, 0.12);

		&:after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			border-radius: 7px;
			pointer-events: none;
			background: linear-gradient(
				356deg,
				rgba(255, 255, 255, 0.04) 0%,
				rgba(255, 255, 255, 0.12) 70%
			);
		}
	}
	ul {
		padding-left: 0;
		counter-reset: LIST-ITEMS 0;
		margin-bottom: 2rem;
		li {
			margin-top: 1rem;
			margin-bottom: 1.5rem;
			margin-left: 0;
			> h4 {
				line-height: 1.4;
				color: $primary;
				text-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
				padding-top: 0.3rem;
			}
		}
	}
	ol {
		counter-reset: LIST-ITEMS 0;
		margin-bottom: 2rem;
		li {
			position: relative;
			margin-top: 1rem;
			margin-bottom: 1.5rem;
			margin-left: 1.75rem;
			&:before {
				position: absolute;
				left: -1rem;
				top: calc(0.5rem - 1px);
				content: ' ';
				height: 8px;
				width: 8px;
				border-radius: 50%;
				background-color: currentColor;
				position: absolute;
				pointer-events: none;
			}
			> h4 {
				line-height: 1.4;
				color: var(--p3);
				text-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
				padding-top: 0.3rem;
			}
			> span {
				display: initial;
				line-height: 1;
				font-size: 0.925rem;
				.keycap {
					color: black;
					font-weight: 500;
				}
			}
			> img {
				border-radius: 6px;
				width: calc(100% + 2.75rem);
				height: auto;
				margin-left: -2.75rem;
				margin-top: 1rem;
				margin-bottom: 0.5rem;
				display: block;
				box-shadow: 0 1px 4px 1px rgba(0, 0, 0, 0.35);
			}
			&:before {
				top: 4px;
				left: -2.75rem;
				width: 32px;
				height: 32px;
				padding: 4px;
				text-align: center;
				content: counter(LIST-ITEMS);
				counter-increment: LIST-ITEMS;
				font-weight: 600;
				background-color: transparent;
				color: var(--p3);
				line-height: 1.25;
				border: var(--p3) solid 2px;
			}
		}
	}
}
</style>